import {css} from 'styled-components';

export default css`

  {/* from bootstrap 5.0 */}

  &.btn, .btn {
    display: inline-block;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    border-radius: 0.25rem;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    font-size: 1rem;
  }

  @media (prefers-reduced-motion: reduce) {
    &.btn, .btn {
      transition: none;
    }
  }

  &.btn:hover, .btn:hover {
    color: #212529;
  }

  &.btn:focus, .btn:focus {
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  }

  &.btn-primary, .btn-primary {
    color: #fff;
    background-color: rgba(0, 123, 255, 1.00);
    border-color: rgba(0, 123, 255, 1.00);
  }

  &.btn-primary:hover, .btn-primary:hover {
    color: #fff;
    background-color: #0b5ed7;
    border-color: #0a58ca;
  }

  &.btn-primary:focus, .btn-primary:focus {
    color: #fff;
    background-color: #0b5ed7;
    border-color: #0a58ca;
    box-shadow: 0 0 0 0.25rem rgba(49, 132, 253, 0.5);
  }

  &.btn-primary:active,
  &.btn-primary.active,
  .btn-primary:active,
  .btn-primary.active {
    color: #fff;
    background-color: #0a58ca;
    border-color: #0a53be;
  }

  &.btn-primary:active:focus,
  &.btn-primary.active:focus,
  .btn-primary:active:focus,
  .btn-primary.active:focus {
    box-shadow: 0 0 0 0.25rem rgba(49, 132, 253, 0.5);
  }

`